import Vue from 'vue';

export default {
    namespaced: true,

    state: {
        loadingCounter: 0,
        orders: []
    },

    getters: {
        isLoading: (state) => () => {
            return state.loadingCounter > 0;
        },

        getAll: (state) => () => {
            return state.orders;
        },

        getById: (state) => (id) => {
            return state.orders.find(item => item.id === id);
        }
    },

    mutations: {
        set(state, { orders }) {
            for(let order of orders) {
                let found = state.orders.find(o => o.id === order.id);

                if(found) {
                    for(let key of Object.keys(order)) {
                        Vue.set(found, key, order[key]);
                    }
                }
                else {
                    state.orders.push(order);
                }
            }
        }
    },

    actions: {
        async fetchAll({ commit, state }, id) {
            let result = await this._vm.$api.get('/api/customers/' + id + '/orders');

            commit('set', { orders: result.records });

            return {
                total: result.count,
                ids: result.records.map(order => order.id)
            };
        },

        fetchOne({ commit, state }, config) {
            state.loadingCounter++;

            let id = config.id;
            let fields = config.fields;

            return this._vm.$api.getOrder(id, fields).then((result) => {
                commit('set', { orders: [ result ] });
            }).finally(() => state.loadingCounter--);
        },

        async create({ commit, state }, order) {
            state.loadingCounter++;

            try {
                let result = await this._vm.$api.post('/api/store/orders', order);
                commit('set', { orders: [result] });

                return result.id;
            }
            finally {
                state.loadingCounter--;
            }
        },

        fetchPayments({ commit, state }, { order }) {
            state.loadingCounter++;

            return this._vm.$api.getOrderPayments(order.id).then((result) => {
                commit('setPayments', { order: order, payments: result });
            }).finally(() => state.loadingCounter--);
        }
    }
};
